// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"480f24df","453":"138daa2f"}[chunkId] + ".chunk.js";
};